/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenAdvertisementResponse } from '../models/Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenAdvertisementResponse';
import type { Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenComplexesResponse } from '../models/Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenComplexesResponse';
import type { Woonstad_Foundation_Portfolio_Api_Models_Components_RoomTypeSummary } from '../models/Woonstad_Foundation_Portfolio_Api_Models_Components_RoomTypeSummary';
import type { Woonstad_Foundation_Portfolio_Api_Models_WRM_IndexedAdvertisement } from '../models/Woonstad_Foundation_Portfolio_Api_Models_WRM_IndexedAdvertisement';
import type { Woonstad_Foundation_Portfolio_Api_Models_WRM_IndexedComplex } from '../models/Woonstad_Foundation_Portfolio_Api_Models_WRM_IndexedComplex';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StadswonenService {

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Models_WRM_IndexedAdvertisement OK
     * @throws ApiError
     */
    public static getApiStadswonenAanbodDetail({
        url,
    }: {
        url?: string,
    }): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Models_WRM_IndexedAdvertisement> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stadswonen/aanbod/detail',
            query: {
                'url': url,
            },
        });
    }

    /**
     * @deprecated
     * @returns Woonstad_Foundation_Portfolio_Api_Models_WRM_IndexedAdvertisement OK
     * @throws ApiError
     */
    public static getApiStadswonenAanbodWrm({
        wocasnr,
    }: {
        wocasnr?: string,
    }): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Models_WRM_IndexedAdvertisement> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stadswonen/aanbod/wrm',
            query: {
                'wocasnr': wocasnr,
            },
        });
    }

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Models_Components_RoomTypeSummary OK
     * @throws ApiError
     */
    public static getApiStadswonenComplexRoomtypes({
        nr,
        culture,
    }: {
        nr?: number,
        culture?: string,
    }): CancelablePromise<Array<Woonstad_Foundation_Portfolio_Api_Models_Components_RoomTypeSummary>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stadswonen/complex/roomtypes',
            query: {
                'nr': nr,
                'culture': culture,
            },
        });
    }

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenComplexesResponse OK
     * @throws ApiError
     */
    public static getApiStadswonenRandomComplex({
        count,
        type,
        lang,
    }: {
        count?: number,
        type?: string,
        lang?: string,
    }): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenComplexesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stadswonen/random/complex',
            query: {
                'count': count,
                'type': type,
                'lang': lang,
            },
        });
    }

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenAdvertisementResponse OK
     * @throws ApiError
     */
    public static getApiStadswonenSearchAanbod({
        qson,
        profile,
        lang = 'nl',
        size = 10,
    }: {
        qson?: string,
        profile?: string,
        lang?: string,
        size?: number,
    }): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenAdvertisementResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stadswonen/search/{lang}/aanbod',
            path: {
                'lang': lang,
            },
            query: {
                'qson': qson,
                'profile': profile,
                'size': size,
            },
        });
    }

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenComplexesResponse OK
     * @throws ApiError
     */
    public static getApiStadswonenSearchComplex({
        qson,
        random,
        size = 10,
    }: {
        qson?: string,
        random?: boolean,
        size?: number,
    }): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenComplexesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stadswonen/search/complex',
            query: {
                'qson': qson,
                'random': random,
                'size': size,
            },
        });
    }

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenAdvertisementResponse OK
     * @throws ApiError
     */
    public static getApiStadswonenSearchComplexAanbod({
        buildingurl,
    }: {
        buildingurl?: string,
    }): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenAdvertisementResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stadswonen/search/complex/aanbod',
            query: {
                'buildingurl': buildingurl,
            },
        });
    }

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenComplexesResponse OK
     * @throws ApiError
     */
    public static getApiStadswonenSearchWoongebouwen({
        qson,
        random,
        size = 10,
        lang,
    }: {
        qson?: string,
        random?: boolean,
        size?: number,
        lang?: string,
    }): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenComplexesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stadswonen/search/woongebouwen',
            query: {
                'qson': qson,
                'random': random,
                'size': size,
                'lang': lang,
            },
        });
    }

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenAdvertisementResponse OK
     * @throws ApiError
     */
    public static getApiStadswonenSearchWoongebouwenAanbod({
        buildingurl = '',
    }: {
        buildingurl?: string,
    }): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenAdvertisementResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stadswonen/search/woongebouwen/aanbod',
            query: {
                'buildingurl': buildingurl,
            },
        });
    }

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Models_WRM_IndexedComplex OK
     * @throws ApiError
     */
    public static getApiStadswonenWoongebouwDetail({
        url,
    }: {
        url?: string,
    }): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Models_WRM_IndexedComplex> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stadswonen/woongebouw/detail',
            query: {
                'url': url,
            },
        });
    }

}
